import PropTypes from 'prop-types';
import React from 'react';
import { useConnect } from 'redux-bundler-hook';
import urlFormatter from 'utils/urlFormatter';

import {
  StyledButton,
  StyledDefaultTemplateHeader,
  StyledDefaultTemplateHeaderLeft,
  StyledHamburgerMenu,
  StyledSelect,
  StyledTitle,
} from './styles';

const DefaultTemplateHeader = ({
  className,
  title,
  doToggleMobileSidebarExpanded,
  mobileSidebarExpanded,
}) => {
  const {
    organizationOptions,
    organizationSelectedOption,
    doUpdateUrl,
    routeInfo: { pattern },
  } = useConnect(
    'selectOrganizationOptions',
    'selectOrganizationSelectedOption',
    'doUpdateUrl',
    'selectRouteInfo',
  );

  const handleChangeOrganization = ({ value }) => {
    const url = urlFormatter({ organizationId: value, url: pattern });
    return doUpdateUrl(url);
  };

  const hasMultipleOrganizations =
    Array.isArray(organizationOptions) && organizationOptions.length > 1;

  return (
    <StyledDefaultTemplateHeader className={className}>
      <StyledDefaultTemplateHeaderLeft>
        <StyledButton
          data-test-id="33a871de-441e-4664-87cb-533c18382b20"
          onClick={() =>
            doToggleMobileSidebarExpanded({ expanded: !mobileSidebarExpanded })
          }
          variant="empty"
        >
          <StyledHamburgerMenu />
        </StyledButton>
        {title ? <StyledTitle>{title}</StyledTitle> : null}
      </StyledDefaultTemplateHeaderLeft>
      {hasMultipleOrganizations && (
        <StyledSelect
          data-test-id="514dfe52-977f-4d40-84f2-474f837ffc3e"
          onChange={handleChangeOrganization}
          options={organizationOptions}
          value={organizationSelectedOption}
        />
      )}
    </StyledDefaultTemplateHeader>
  );
};

DefaultTemplateHeader.propTypes = {
  className: PropTypes.string,
  doToggleMobileSidebarExpanded: PropTypes.func.isRequired,
  mobileSidebarExpanded: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

DefaultTemplateHeader.defaultProps = {
  className: '',
};

export default DefaultTemplateHeader;
